'use client';

import { FooterNav } from '@petsmart-ui/sparky';
import { dataLayerPush, layoutEvents } from '@libs/analytics';
import { handleServiceClick } from '@libs/experience-api';
import { usePageLayout } from '@libs/common-next';
import type { LegacyFooterLinksProps } from './types';

export function LegacyFooterLinks({ links }: LegacyFooterLinksProps) {
    const { isAuthenticated } = usePageLayout();

    if (!links || links.length === 0) {
        return null;
    }

    return links.map(({ actionText, webUrl, sysId }) => (
        <FooterNav.Item
            onClick={event => {
                handleServiceClick({
                    authType: isAuthenticated,
                    event,
                    link: webUrl,
                });

                dataLayerPush({
                    ...layoutEvents.footerClick,
                    selection: actionText,
                    link_url: webUrl,
                });
            }}
            href={webUrl}
            key={sysId}
            text={actionText}
        />
    ));
}
